// extracted by mini-css-extract-plugin
export var attachment = "_rv-a";
export var emailContainer = "_rv-4";
export var emailContentPaddedContainer = "_rv-b";
export var emailHeader = "_rv-6";
export var emailIframe = "_rv-3";
export var emailInfoIcon = "_rv-9";
export var emailShortenedSummary = "_rv-e";
export var infoDropdown = "_rv-0";
export var infoRowBoundedContent = "_rv-d";
export var internal = "_rv-5";
export var merchant = "_rv-8";
export var messageInputContainer = "_rv-h";
export var normal = "_rv-7";
export var replyCard = "_rv-f";
export var subtleButton = "_rv-1";
export var subtleButtonIconContainer = "_rv-2";
export var toggleViewRepliesButton = "_rv-c";
export var wrappingText = "_rv-g";